/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line
class PlaylistPage extends Component {
  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.playlistPage.isLoading) {
      return (
        <section className="playlist-page">
          <article className="playlist-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    return (
      <section className={'playlist-page'}>
        <h2>WIP</h2>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    // config: state.config || {},
    status: state.status.code,
    playlistPage: state.playlistPage
  };
}

PlaylistPage.propTypes = {
  // config: PropTypes.shape(),
  status: PropTypes.number,
  playlistPage: PropTypes.shape()
};

export default withRouter(connect(mapStateToProps)(PlaylistPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/playlist_page/playlist_page.js